import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const Twitter = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 20L10.8571 13.1429M10.8571 13.1429L16 20H20L13.1429 10.8571M10.8571 13.1429L4 4H8L13.1429 10.8571M13.1429 10.8571L20 4"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Twitter;
